export default __webpack_public_path__ + "locales/lo-LA/Common.json?hash=88d7d8a42b0f3151a89b8a3eaacda0c7";